import * as io from 'io-ts';
import { numberInRange } from '@shared/core/types/common';

export const orderTypeIdsArray = io.array(numberInRange(1));
